<footer class="contenedor" [ngStyle]="{'background-color': menuStyle.bgBarraSuperior}">
    <p class="text-center">Hostelemétrica - 2024 | WEB desarrollada por Augusto Salti</p>
</footer>